import { useMutation } from '@tanstack/react-query';
import { useApi } from '../../../hooks/useApi';

export type EligibilityRequestPayload = {
  user_id: string;
  member_id?: string;
  user_email?: string;
  first_name?: string;
  last_name?: string;
  group_id?: string;
  relationship_to_subscriber: string;
  subscriber?: {
    member_id: string;
    date_of_birth: string;
    gender: string;
    first_name: string;
    last_name: string;
  };
};

export const useEligibilityRequest = () => {
  const { api } = useApi({ throwIfError: true });

  const mutation = useMutation({
    mutationFn: (userData: EligibilityRequestPayload) => {
      return api({
        route: `/eligibility_request/`,
        method: 'POST',
        payload: userData,
      });
    },
  });

  return { mutation };
};

export default useEligibilityRequest;
